import type { ReactNode } from 'react';

export const symbol_door_sliding: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M344.5-459.5Q334-470 334-484t10.5-24.5Q355-519 369-519t24.5 10.5Q404-498 404-484t-10.5 24.5Q383-449 369-449t-24.5-10.5Zm223 0Q557-470 557-484t10.5-24.5Q578-519 592-519t24.5 10.5Q627-498 627-484t-10.5 24.5Q606-449 592-449t-24.5-10.5ZM150-120q-12.75 0-21.37-8.63Q120-137.25 120-150q0-13 8.5-21.5T150-180h16v-600q0-24 18-42t42-18h508q24 0 42 18t18 42v600h16q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H150Zm76-60h224v-600H226v600Zm284 0h224v-600H510v600Zm-30-332Z"
		/>
	</svg>
);
